<p-confirmpopup></p-confirmpopup>
<p-toast [baseZIndex]="20000"></p-toast>
<div class="filter-dropdown-container-dis">

  <!-- <span class="p-float-label">
  <p-datepicker [showIcon]="true" class="calender-icon" [(ngModel)]="selectedUpdateDate"
    (onSelect)="onUpdateDateChange($event)" placeholder="Updated" inputId="icon">
  </p-datepicker>
  <label style="display: block;font-size: 16px; color: rgb(33, 37, 41);">
    Updated
  </label>
</span> -->

<app-datepicker [(ngModel)]="selectedUpdateDate" (onSelectChange)="onUpdateDateChange($event)"
[inputlabel]="'Updated'"></app-datepicker>

<app-dropdown [options]="typeOptions" [(selectedValue)]="selectedType" (selectedValueChange)="onTypeChange($event)"
placeholder="Type" aria-label="Type" label="Type" [showFloatingLabel]="true"></app-dropdown>


<app-dropdown [options]="districtOptions" [(selectedValue)]="selectedDistrict"
  (selectedValueChange)="onDistrictChange($event)" placeholder="District" aria-label="District" label="District"
[showFloatingLabel]="true"></app-dropdown>

<!-- <span class="p-float-label">
<p-datepicker [showIcon]="true" class="calender-icon" [(ngModel)]="selectedSchedDate"
  (onSelect)="onScheduledDateChange($event)" placeholder="Sched Date" inputId="icon">
</p-datepicker>
<label style="display: block;font-size: 16px; color: rgb(33, 37, 41);">
  Sched Date
</label>
</span> -->

<app-datepicker [(ngModel)]="selectedSchedDate" (onSelectChange)="onScheduledDateChange($event)"
[inputlabel]="'Sched Date'"></app-datepicker>
<div>
  <button pButton type="button" label="Search" class="search-button" (click)="onSearch()"></button>
  <button pButton type="button" label="Clear" class="clear-button" (click)="onClear()"></button>
</div>
</div>

@if (isLoading) {
  <div class="loading-container">
    <p-progressSpinner>
      <style class="custom-spinner"></style>
    </p-progressSpinner>
    <p>{{ processMessage }}</p>
  </div>
}

<app-table #tblConfig [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="lsNorthDataColumns"
  [rows$]="filteredData$" [pageSize]="10" [totalRecords]="totalRecords" (onAction2ButtonClicked)="onReloadClicked()"
  [actionButtons]="actionButtons" (pageChanged)="onPageChanged($event)" (sortClicked)="onSortClicked($event)"
(onSearchText)="onSearchText($event)" (onCellClicked)="onCellClicked($event)"></app-table>